import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { PaymentService, PaymentV2Service, UtilService, VariablesService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-upi',
  templateUrl: './payment-upi.component.html',
  styleUrls: ['./payment-upi.component.scss']
})
export class PaymentUpiComponent implements OnInit, OnDestroy {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();
  qrURL;
  selectedUPI;
  subs: Subscription[] = [];
  isMobile;

  constructor(
    public util: UtilService,
    public paymentV2: PaymentV2Service,
    public paymentService: PaymentService,
    public vars: VariablesService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
    // if (this.util.getMobileOperatingSystem() === 'iOS' || this.config?.upiMode?.value === 'OTHER') {
    this.selectedUPI = 'other';
    // }
    this.checkForUpiPayment();
  }


  checkForUpiPayment() {
    this.subs.push(
      this.vars.upi_payment_status.subscribe(val => {
        if (val === 'success') {
          this.dialog.closeAll();
          this.vars.upiTimer = false;
          this.util.router.navigate(['/new/payment-route'], { queryParams: this.vars.tyParams });
        } else if (val === 'failed') {
          this.vars.upiTimer = false;
        }
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
